import React from 'react'
import AppDetailsHeader from './AppDetailsHeader'
import AppInfo from './AppInfo'

const AppDetailsPage = () => {
    return (
        <div>
            <AppDetailsHeader />
            <AppInfo />
        </div>
    )
}

export default AppDetailsPage
